const BaseStatusUtils = require('./base');
const { invoiceStatusList, invoiceStatusMapping } = require('pando-constants');
const { differenceBy, cloneDeep, result, find } = require('lodash');

class StatusUtils extends BaseStatusUtils {
  constructor(globalStatusList, statusMapping) {
    super(cloneDeep(globalStatusList), statusMapping);
    this.injectHelpers();
  }

  injectHelpers() {
    this.baseStatuses.forEach((status) => {
      this.defineMethod(`${status.name}_has_parent`,
        (statusId, featureEnabled) => {
          let parent;
          if (featureEnabled) {
            parent = result(find(status.parent, obj =>
              obj.features && obj.features === featureEnabled), 'ids');
          }
          return parent && parent.includes(statusId);
        },
      );
    });
  }

  isValidParent(statusName, cuurentStatusId, featureEnabled) {
    return this[`${statusName}_has_parent`] &&
      this[`${statusName}_has_parent`](cuurentStatusId, featureEnabled);
  }

  isBaseStatus(statusId) {
    return this.baseStatuses.includes(statusId);
  }

  getStatusObjById(statusId) {
    return this.baseStatuses.find(status => status.id === statusId);
  }

  getStatusObjByName(statusName) {
    return this.baseStatuses.find(status => status.name === statusName);
  }

  getStatusByActionaleParty(party) {
    return this.baseStatuses.filter(status => status.actionAllowedParties.includes(party));
  }

  get baseStatusIds() {
    return this.baseStatuses.map(status => status.id);
  }

  get baseStatuses() {
    return differenceBy(this.globalStatusList, this.mainStatus, 'id');
  }
}

module.exports = new StatusUtils(invoiceStatusList, invoiceStatusMapping);
